<template>
  <div class="wrap">
    <div class="content">
      <div class="field-wrap">
        <van-field
          class="field"
          placeholder="请输入正确订单号"
          v-model="outOrderId"
          @input="showErrorMessage = false"
        />
        <div class="fail-message" v-if="showErrorMessage">
          订单号错误，请检查短信重新输入
        </div>
      </div>
      <div class="btn active" @click="handleDraw">立即激活</div>
      <div class="btn draw" @click="handleDraw">已激活 去使用</div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { defineComponent, ref } from "@vue/composition-api";
import axios from "axios";

const vm = Vue.prototype;

export default defineComponent({
  setup() {
    const outOrderId = ref("");
    const showErrorMessage = ref(false);

    const handleDraw = async () => {
      if (!outOrderId.value) {
        showErrorMessage.value = true;
        vm.$toast("请输入正确订单号");
        return;
      }
      const loading = vm.$loading();

      const { data } = await axios.post(
        process.env.VUE_APP_RUNTIME_ENV === "production"
          ? "https://page.lianrongkeji.com/openapi/h5/right/getXsRightExchangeUrl"
          : "https://page-dev.lianrongkeji.com/openapi/h5/right/getXsRightExchangeUrl",
        {
          channel_order_id: outOrderId.value,
        }
      );
      if (data.code === 200) {
        window.location.href = data.data.exchange_url;
        window.location.reload();
      } else {
        showErrorMessage.value = true;
        vm.$toast(data.message);
      }
      loading.clear();
    };

    return {
      handleDraw,
      outOrderId,
      showErrorMessage,
    };
  },
});
</script>

<style scoped lang="less">
.wrap {
  height: 100vh;
  background: #f5f5f5;

  .content {
    overflow: hidden;
    width: 351px;
    height: 239px;
    background: #ffffff;
    border-radius: 8px;
    backdrop-filter: blur(10px);
    box-sizing: border-box;
    margin: 0 auto;
    margin-top: 108px;

    .field-wrap {
      margin-top: 10px;
      position: relative;
      .field {
        width: 295px;
        margin: 0 auto;
        &::after {
          content: "";
          display: block;
          width: 295px;
          height: 1px;
          border: 1px solid #dcdcdc;
        }
        /deep/.van-field__control {
          &::placeholder {
            text-align: center;
          }
        }
      }

      .fail-message {
        position: absolute;
        bottom: -23px;
        left: 50%;
        transform: translateX(-50%);
        font-weight: 300;
        font-size: 12px;
        color: #ff3141;
        line-height: 17px;
        text-align: center;
        white-space: nowrap;
      }
    }

    .btn {
      width: 327px;
      height: 48px;
      border-radius: 25px;
      margin: 0 auto;
      margin-top: 42px;
      font-weight: 500;
      font-size: 16px;
      line-height: 48px;
      text-align: center;
      &.active {
        color: #e0c7b3;
        background: linear-gradient(180deg, #1f1f1f 0%, #0a0708 100%);
      }
      &.draw {
        width: 325px;
        height: 46px;
        background: #fff;
        border: 1px solid #3b332f;
        color: #39312d;
        margin-top: 16px;
      }
    }
  }
}
</style>

